// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ShopLoading-Wrapper-2n237t","Loading":"ShopLoading-Loading-2RiPud"};